import * as orderAction from './order'

export const ActionCreators = Object.assign({},orderAction);
// export const ActionCreators = Object.assign({},);
